import { Component, OnInit, OnDestroy, OnChanges , SimpleChanges} from '@angular/core';

import { TableService } from '../../services/integrated/table.service';
import { ActivatedRoute } from '@angular/router';
import { isNgTemplate } from '@angular/compiler';
import { Globals } from '../../globals';


@Component({
    selector: 'app-products',
    templateUrl: './products.component.html',
    styleUrls: ['./products.component.css'],
    providers: [TableService]
})
export class ProductsComponent implements OnInit , OnDestroy , OnChanges {
    public link;
    public connect;
    public brand: any = [];
    public origin: any = [];
    public price: any = { min: 0, max: 0 };
    private cols = [
        { field: 'name', filter: true },
    ];
    public token: any = {
        catalogry: "api/productcatalogry",
        getproduct: "api/getlistProduct"
    }
    constructor(public globals: Globals, public cwstable: TableService, public route: ActivatedRoute) {
        
        this.route.params.subscribe(params => {
            let link = params.parent_link;
            if (link && link.length > 0) {
                this.globals.send({ path: this.token.catalogry, token: 'productcatalogry', params: { link: link } });
            }
            else {
                this.globals.send({ path: this.token.getproduct, token: 'getproduct' });
            }
        });
        this.connect = this.globals.result.subscribe((res: any) => {
            switch (res.token) {
                case "getproduct":
                    if (res.data.length > 0) {
                        this.cwstable._ini({ cols: this.cols, data: res.data });
                        this.extract();
                    }
                    break;
                case "productcatalogry":
                    if (res.data.length > 0) {
                        this.cwstable._ini({ cols: this.cols, data: res.data });
                        this.extract();
                    }
                    break;
                default:
                    break;
            }
        });
    }

    ngOnInit() {
       

    }
    ngOnChanges(e: SimpleChanges) {

    }
    ngOnDestroy(){
        this.connect.unsubscribe();
    }
    extract = () => {
        let brand = {};
        let origin = {};
        let price = { min: 0, max: 0 };
        if (this.cwstable.cachedList.length > 0) {
            price.min = (+this.cwstable.cachedList[0].price_sale > 0) ? +this.cwstable.cachedList[0].price_sale : +this.cwstable.cachedList[0].price_buy;
        }
        this.cwstable.cachedList.reduce((n, o, i) => {
            if (!brand[o.brand_id]) {
                brand[o.brand_id] = { id: o.brand_id, name: o.brand_name, count: 0 };
            }
            if (brand[o.brand_id]) {
                brand[o.brand_id].count = +brand[o.brand_id].count + 1;
            }

            if (!origin[o.origin_id]) {
                origin[o.origin_id] = { id: o.origin_id, name: o.origin_name, count: 0 };
            }
            if (origin[o.origin_id]) {
                origin[o.origin_id].count = +origin[o.origin_id].count + 1;
            }
            let p = (+o.price_sale > 0) ? +o.price_sale : +o.price_buy;
            price.min = p < price.min ? p : price.min;
            price.max = p > price.max ? p : price.max;
            return n;
        }, {});
        this.brand = Object.values(brand);
        this.origin = Object.values(origin);
        //this.brand.push({id : 2 , name : 'test' , count : 0})
        this.price = price;
    }
    filterBrand = (id) => {
        let token = "brand_id";
        let filter = this.cwstable._getFilter(token);
        let data = !filter.value ? {} : filter.value.reduce((n, o, i) => {
            n[o] = o;
            return n;
        }, {});
        let value = [];
        if (data[id]) {
            value = filter.value.filter(item => {
                return +item == id ? false : true;
            });
        } else {
            value.push(id);
        }
        if (value.length == 0) {
            this.cwstable._delFilter(token);
        } else {
            this.cwstable._setFilter(token, value, 'in');
        }
    }
    filterOrigin = (id) => {
        let token = "origin_id";
        let filter = this.cwstable._getFilter(token);
        let data = !filter.value ? {} : filter.value.reduce((n, o, i) => {
            n[o] = o;
            return n;
        }, {});
        let value = [];
        if (data[id]) {
            value = filter.value.filter(item => {
                return +item == id ? false : true;
            });
        } else {
            value.push(id);
        }
        if (value.length == 0) {
            this.cwstable._delFilter(token);
        } else {
            this.cwstable._setFilter(token, value, 'in');
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/frontend/products/products.component.ts